import { Box, Divider, Typography } from '@mui/material';

import type { FactsheetDetails } from '@/features/Factsheet/types';
import { parseVersionHistoryText } from '@/features/Factsheet/utils/versionHistory';

import TextLinesDisplay from './TextLinesDisplay';

interface ApproachTabProps {
  factsheet: FactsheetDetails;
}

interface TradeDataRowProps {
  label: string;
  value: boolean | string | undefined;
}

const tradeDataRowSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  pt: 0.5
};

const approachSectionSx = {
  display: 'flex',
  minWidth: '50%',
  maxWidth: '50%',
  flexDirection: 'column',
  pl: 1,
  pr: 2
};

const approachHeaderSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: 0.5
};

const headerTextSx = { fontWeight: 700 };
const dividerSx = { backgroundColor: 'text.primary', pr: 4 };
const rootSx = { display: 'flex', justifyContent: 'flex-start' };
const textColSx = { display: 'flex', flexDirection: 'column', pr: 1, pl: 2 };

const TradeDataRow = ({ label, value }: TradeDataRowProps) => (
  <Box sx={tradeDataRowSx}>
    <Typography>{label}</Typography>
    <Typography>{value ? 'Y' : 'N'}</Typography>
  </Box>
);

const TradeDataApproachSection = ({ factsheet }: { factsheet: FactsheetDetails }) => (
  <Box sx={approachSectionSx}>
    <Box sx={approachHeaderSx}>
      <Typography
        sx={headerTextSx}
        variant='body2'
      >
        Trade Data Approach
      </Typography>
      <Typography
        sx={headerTextSx}
        variant='body2'
      >
        Y/N
      </Typography>
    </Box>
    <Divider sx={dividerSx} />
    <TradeDataRow
      label='Priority to reported and concluded transactions'
      value={factsheet.priorityToTransactions}
    />
    <TradeDataRow
      label='Sole-sourced data from trading principals accepted'
      value={factsheet.soleSourcedDataAccepted}
    />
    <TradeDataRow
      label='Inter-affiliate data accepted as valid'
      value={factsheet.interAffiliateDataAccepted}
    />
  </Box>
);

const ApproachTab = ({ factsheet }: ApproachTabProps) => {
  const approachLines = parseVersionHistoryText(factsheet, 'calculationApproach');

  return (
    <Box sx={rootSx}>
      <TradeDataApproachSection factsheet={factsheet} />
      <Box sx={textColSx}>
        <TextLinesDisplay lines={approachLines} />
      </Box>
    </Box>
  );
};

export default ApproachTab;
